<a [routerLink]="['/profile-check/educations', education.id]" class="vacancy-card vacancy-card--opleidingen">
  <h3 class="vacancy-card__title">{{ education.title }}</h3>

  <p class="education-card__institution">
    {{ 'educations.card.institution_prefix' | translate }} <span class="education-card__institution-name">{{ education.institution }}</span>
  </p>

  <div class="education-card__info">
    <div class="education-card__info-row">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="education-card__icon">
        <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/>
      </svg>
      <span>{{ education.location }}</span>
    </div>
    <div class="education-card__info-row">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="education-card__icon">
        <rect width="18" height="18" x="3" y="4" rx="2" ry="2"/><line x1="16" x2="16" y1="2" y2="6"/><line x1="8" x2="8" y1="2" y2="6"/><line x1="3" x2="21" y1="10" y2="10"/>
      </svg>
      <span>{{ education.startDate }}</span>
    </div>
    <div class="education-card__info-row">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="education-card__icon">
        <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
      </svg>
      <span>{{ education.duration }}</span>
    </div>
  </div>

  <div class="education-card__format">
    <div class="education-card__format-label">{{ 'educations.card.learning_formats' | translate }}</div>
    <div class="education-card__format-value">{{ education.format }}</div>
  </div>

  <div class="vacancy-card__actions">
    <button
      class="vacancy-btn-round vacancy-btn-heart"
      [class.vacancy-btn-heart--active]="isLiked"
      (click)="onLike($event)"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" [attr.fill]="isLiked ? 'currentColor' : 'none'" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>
      </svg>
    </button>
    <span class="vacancy-btn-round vacancy-btn-arrow">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>
      </svg>
    </span>
  </div>
</a>
